import React from "react";

function PUM() {
  return (
    <div className="bg-warning border p-4 m-5">
      <h6>You are PUM</h6>
    </div>
  );
}

export default PUM;
